import { Helmet } from 'react-helmet';
import NewdanhmuckhachhangDetail
  from 'src/components/newdanhmuckhachhang-detail/NewdanhmuckhachhangDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import NewdanhmuckhachhangListToolbar from '../components/newdanhmuckhachhang-detail/NewdanhmuckhachhangToolbar';

const Newdanhmuckhachhang = () => (
  <>
    <Helmet>
      <title>Danh mục khách hàng</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <NewdanhmuckhachhangListToolbar />
        <Box sx={{ pt: 3 }}>
          <NewdanhmuckhachhangDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Newdanhmuckhachhang;
